// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3h5te","footer":"ModalInfo_footer__DN8pU"};